<div class="flex flex-column align-items-center">
    <!--inputswitch button begin-->
    <div class="flex align-items-center border-round-xl bg-blue-50 p-2">
        <span class="text-lg">{{ 'sipo.payment-component.monthly' | translate }}</span>
        <p-inputSwitch class="mx-3" [(ngModel)]="isYearly"></p-inputSwitch>
        <span class="text-lg">{{ 'sipo.payment-component.yearly' | translate }}</span>

    </div>
    <p class="text-2xl text-red-500 font-bold" *ngIf="!isYearly">{{ "sipo.packages.basic.earlyBird" | translate }}</p>

    <!--inputswitch button end-->
    <!--package info cards begin-->
    <div class="grid w-full mt-3">
        <div class="flex justify-content-center"
             [ngClass]="packages.length === 3 ? 'col-4' : 'col-6'"
             *ngFor="let pack of packages; let i = index">
            <div class="card p-4 flex flex-column relative overflow-hidden"
                 [ngClass]="packages.length === 3 ? 'w-11' : 'w-8'">
                <div
                    class="absolute left-0 top-0 w-full h-full z-5 pt-8 flex flex-column align-items-center p-3"
                    style="background-color: rgba(255,255,255,0.8);"
                    *ngIf="isAutoRouted && pack.name === 'Starter'">
                    <i class="pi pi-clock font-bold text-red-500 mb-3" style="font-size: 7.5rem;"></i>
                    <div class="text-red-500 font-bold text-3xl flex justify-content-center text-center">
                        {{ 'sipo.payment-component.plan-selection-component.trial-expired-message' | translate:{appName: appConfig.name} }}
                    </div>
                </div>
                <!--title and top-right-badge begin-->
                <div class="text-center">
                    <div class="font-bold text-4xl">{{ pack.name }}</div>
                    <div class="border-round-lg p-2" [ngClass]="pack.name === 'Starter' ? 'bg-gray-100' : 'bg-secondary'">
                        {{ pack.topBadgeInfo }}
                    </div>
                </div>
                <!--title and top-right-badge end-->
                <!--price begin-->
                <div class="text-3xl mt-2 text-center">
                    <span *ngIf="pack.name != 'Starter'">
                        <span *ngIf="!isYearly">
                            {{ pack.priceMonthly | number:'1.2-2' }} {{ pack.currency | currencySymbol }}
                            / {{ 'sipo.payment-component.month' | translate }}
                        </span>
                        <span *ngIf="isYearly">
                            {{ pack.priceYearly | number:'1.2-2' }} {{ pack.currency | currencySymbol }}
                            / {{ 'sipo.payment-component.year' | translate }}
                        </span>
                    </span>
<!--                    <p class="text-sm text-red-500 font-bold" *ngIf="!isYearly">{{ pack.earlyBird | translate }}</p>-->
                    <span *ngIf="pack.name === 'Starter'">
                        {{ 'sipo.payment-component.plan-selection-component.free' | translate }}
                    </span>
                </div>
                <!--price end-->
                <!--description begin-->
                <div class="my-2 text-gray-500 text-2xl text-center">
                    {{ pack.planDescription }}
                </div>
                <!--description end-->
                <p-divider></p-divider>
                <!--package contents begin-->
                <div class="mb-5">
                    <ul class="pl-4">
                        <li class="text-1xl py-2" *ngFor="let content of pack.contents">
                            {{ content }}
                        </li>
                    </ul>
                </div>
                <!--package contents end-->
                <!--confirm button begin-->
                <div class="w-full mt-auto pt-3">
                    <button *ngIf="userSubscription?.plan != pack.name"
                            (click)="changeSelectedPackage(i)"
                            [class.p-disabled]="pack.name === 'Starter'"
                            class="p-button bg-secondary w-full font-bold flex justify-content-center">
                        {{ 'sipo.payment-component.buy-now' | translate }}
                    </button>
                    <div *ngIf="userSubscription?.plan === pack.name"
                         class="p-button bg-secondary p-disabled w-full font-bold flex justify-content-center">
                        {{ 'sipo.payment-component.plan-selection-component.current-plan' | translate }}
                    </div>
                </div>
                <!--confirm button end-->
            </div>
        </div>
    </div>
    <!--package info cards end-->
    <!--bottom info and payment methods begin-->
    <div class="w-5 text-center text-xl">
          {{ 'sipo.payment-component.plan-selection-component.price-including' | translate }}
    </div>
    <div class="w-7 font-bold text-center">
    <img class="w-2" src="assets/images/payment/visa.svg">
    <img class="w-1" src="assets/images/payment/mastercard.svg">
    <img class="w-2" src="assets/images/payment/paypal-multicolor.svg">
</div>
    <!--bottom info and payment methods end-->
</div>
